import { ChangeDetectorRef, Component, Input, Inject } from "@angular/core";
import * as GoldenLayout from "golden-layout";

import {
  GoldenLayoutComponentState,
  GoldenLayoutContainer,
} from "golden-layout/golden-layout.directive";
import { AfterViewChecked, OnChanges } from "@angular/core";
import { UserService } from "@app/services/user.service";
import { User } from "@app/data/user";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { GoldenLayoutBaseComponent } from "@app/components/editor/workspace/golden-layout-base.component";
import {
  TEXT_COMPONENT_KEY,
  LISTING_QRCODE_COMPONENT_KEY,
} from "@app/components/editor/workspace/golden-layout-definitions";
import { SimpleChanges } from "@angular/core";
import { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";
import { Listing } from "@app/data/listing";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { SecurityContext } from "@angular/core";
import { CurrencyPipe } from "@angular/common";
import * as tearSheetUtils from "@js/tear-sheet.utils";

@Pipe({
  name: "renderQRCode",
  pure: false,
})
export class RenderQRCodePipe implements PipeTransform {
  oldListingsString: string;
  oldStateString: string;
  templateHtml: SafeHtml;
  previewHtml: SafeHtml;
  constructor(private sanitizer: DomSanitizer) {}

  transform(state: any, listing: Listing, preview: boolean): any {
    var stateString = JSON.stringify(state);
    var listingsString = JSON.stringify(listing);
    if (
      !this.oldStateString ||
      stateString !== this.oldStateString ||
      listingsString !== this.oldListingsString
    ) {
      this.oldStateString = stateString;
      this.oldListingsString = listingsString;
      let html = tearSheetUtils.createQRCodeTemplate(state);
      this.templateHtml = this.sanitizer.bypassSecurityTrustHtml(html);
      this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(
        tearSheetUtils.replaceQRCode(html, listing)
      );
    }
    if (preview) {
      return this.previewHtml;
    }
    return this.templateHtml;
  }
}

@Component({
  templateUrl: "./golden-layout-listing-qrcode.component.html",
})
export class GoldenLayoutListingQRCodeComponent extends GoldenLayoutBaseComponent {
  listing: Listing;

  constructor(
    @Inject(GoldenLayoutComponentState) state: any,
    @Inject(GoldenLayoutContainer) container: GoldenLayout.Container,
    goldenLayoutService: GoldenLayoutService,
    cdRef: ChangeDetectorRef
  ) {
    super(state, container, goldenLayoutService, cdRef);
    this.goldenLayoutService.getListing().subscribe((listing) => {
      this.listing = listing;
    });
  }
  onClick() {
    this.select(LISTING_QRCODE_COMPONENT_KEY);
  }
}
